import { z } from 'zod'

import { VenueTrustSignalDomain } from '~/shared/venue/trust-signals'

export const ListVenueTrustSignalDetailsInput = z.object({
  venueId: z.number().int().positive(),
  sourceDomain: z.nativeEnum(VenueTrustSignalDomain),
})

export const VenueTrustSignalDetail = z.object({
  sourceTitle: z.string(),
  sourceLastUpdatedDate: z.string().nullable(),
  sourcePublishedDate: z.string().nullable(),
  venueDescription: z.string().nullable(),
  signalUrl: z.string().nullable(),
})

export const ListVenueTrustSignalDetailsOutput = z.object({
  trustSignals: z.array(VenueTrustSignalDetail),
})

export type VenueTrustSignalDetail = z.infer<typeof VenueTrustSignalDetail>
export type ListVenueTrustSignalDetailsInput = z.infer<typeof ListVenueTrustSignalDetailsInput>
